<div class="container" kendoTooltip showAfter="5000">
  <CDMS-Portal-U2-main-header></CDMS-Portal-U2-main-header>
  @if (userHasNoAccess) {
    <div class="access-message">
      <p>You do not have access to this page. Please contact system administrator.</p>
    </div>
  }
  @if (!userHasNoAccess) {
    <router-outlet></router-outlet>
  }
</div>

@if (sessionExpires) {
  <kendo-dialog class="custom-dialog custom-dialog-timeout" title="">
    <p class="dialog-text p-0">Your session has been timed out</p>
    <kendo-dialog-actions class="text-center">
      <div>
        <button
          kendoButton
          class="cdms-btn-blue k-button"
          (click)="close()"
          primary="true"
          data-test-id="cdms-btn-close-timeout"
          >
          OK
        </button>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
}

<common-loading-indicator [show]=" AppConstants.showLoading"></common-loading-indicator>

<iframe  class="ifame-logout" [attr.src]="url ? url : null" title="" (load)="onFrameLoad()"></iframe>

@if (showConfirmation) {
  <authorization-change-confirmation
    (authorizationChangeConfirmationDataItem)="onAuthorizationChangeConfirmationDataItem($event)">
  </authorization-change-confirmation>
}
